module.exports = __webpack_public_path__ + "static/media/prrlogo.d5520566.jpg";